export enum SearchTab {
    Regions,
    Places,
    Offers,
    Vendors,
    Holiday
}
